module.exports = __webpack_public_path__ + "static/img/id-icon.c9442eee.png";